module.exports = __webpack_public_path__ + "img/logo-carbo-brake.ed460ff9.jpg";